module.exports = __webpack_public_path__ + "static/img/RYE-PENNY.208df06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RYE-PENNY.jpg
// module id = IMRU
// module chunks = 0